import { Validators } from '@angular/forms';
import { ValidatorUtils } from './validator.utils';
import { LangConstants } from '../../constants';

export class FormValidatorUtils extends ValidatorUtils  {

    public static messages: any = {
        url: {
            'required': 'required-url',
            'pattern' : 'invaild-url'
        },
        email: {
            'required': 'validation-empty-email'
        },
        password: {
            'required': 'validation-empty-password',
            'minlength': 'validation-minlength-password',
            'maxlength': 'validation-maxlength-password'
        },
        input: {
            'required': 'validation-empty-password'
        },
        cndVal : {
            'required': 'MK.00608'
        },
        suppTime : {
            'required': 'validation-empty-suppTime'
        },
        msg : {
            'required': '1111111111111'
        },
        responder : {
            'required': 'validation-empty-responder'
        },
        ltncyTm : {
            'required': 'validation-empty-ltncyTm'
        },
        reptCnt : {
            'required': 'validation-empty-reptCnt'
        },
        name : {
            'required': 'validation-empty-name'
        },
        serviceName : {
            'required': 'validation-empty-serviceName'
        },
        serviceMember : {
            'required': 'validation-empty-serviceMember'
        },
        escalReptCnt : {
            'required': 'validation-empty-number'
        },
        reptNotiCnt : {
            'required': 'validation-empty-number'
        },
        reptIntvVal : {
            'required': 'validation-empty-number'
        },
        lastTime : {
            'required': 'MK.00616'
        }
    };

    public static watchValueChanged(form?: any, targets?: any, data?: any): any {
        if (!form) {
            return;
        }

        for (const field in targets) {
            targets[field] = '';
            const control = form.get(field);

            if (control && !control.valid) {
                const messages = FormValidatorUtils.messages[field];
                for (const key in control.errors) {
                    targets[field] += messages[key];
                }
            }
        }

        return targets;
    }

    public static emailRuleSet(target: any): any {
        return [target, [
            Validators.required
            ]
        ];
    }

    // Regex 보안 이슈로 주석 처리
    // public static urlRuleSet(target: any): any {
    //     return [target, [
    //         Validators.required,
    //         Validators.pattern(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/g)
    //         /*Validators.pattern(/((http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w��-�롢뀖-�ｊ�-��\;\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/g)*/
    //     ]
    //     ];
    // }

    public static passwordRuleSet(target: any): any {
        return [target, [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(12)
            ]
        ];
    }

    public static inputRuleSet(target: any): any {
        return [target, [
            Validators.required
            ]
        ];
    }

    public static cndValRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    }

    public static suppTimeRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    }

    public static msgSpecCheckBoxRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    }

    public static ltncyTmRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };

    public static reptCntRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };

    public static responderRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };

    public static nameRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };

    public static numberRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };

    public static memberRuleSet(target: any): any {
        return [target, [
            Validators.required
        ]
        ];
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/form-validator.utils.ts